module.exports = __webpack_public_path__ + "static/media/MONEDERO_B.23c6f867.svg";